export default __webpack_public_path__ + "static/media/earnings-bg.252d82fc.webp";